<template>
  <div class="page-title-component">
    <section class="hero" v-bind:class="backgroundClass">
      <div class="hero-body">
        <div
          class="container has-text-centered-touch"
          v-anime="{
            translateX: [-2000, 0],
            duration: 200,
            easing: 'easeOutExpo'
          }"
        >
          <h3 class="title has-padding-bottom-10">
            {{ title }}
          </h3>
          <h2 class="subtitle">
            {{ subtitle }}
          </h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PageTitleComponent",
  props: {
    title: String,
    subtitle: String,
    backgroundClass: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
